<template>
  <div>
    <Print_barcode/>
  </div>
</template>

<script>
import Print_barcode from "@/components/adminArin/pos_system/warehouse/printbarcode/Print_barcode";
export default {
  name: "printbarcode",
  components: {
    Print_barcode
  }
}
</script>

<style scoped>

</style>
